(function($){
  if (!$) { return; }
  $(function(){
    // Remove the blanket prevention handler to allow conditional behavior
    try {
      $(document).off('click', '.has-mega-menu .menu-item__link');
    } catch (err) {
      // no-op if not present
    }

    // Re-bind: first tap expands, icon tap toggles close/open, label tap when expanded navigates
    $(document).on('click', '.has-mega-menu .menu-item__link', function(e){
      var link = this;

      // Identify mobile-style mega menu links by presence of icon and sibling submenu
      var hasIcon = link.querySelector && (link.querySelector('i.fa-plus') || link.querySelector('i.fa-minus'));
      var submenu = link.nextElementSibling;
      var hasSubmenu = submenu && submenu.classList && submenu.classList.contains('custom-mega-menu');

      if (!hasIcon || !hasSubmenu) {
        // Desktop or non-target links; allow default behavior
        return;
      }

      var expanded = link.getAttribute('aria-expanded') === 'true';
      var isIconClick = $(e.target).closest('i.fa-plus, i.fa-minus').length > 0;

      // If collapsed, always open instead of navigating
      if (!expanded) {
        e.preventDefault();
        if (typeof window.updateMobileMenuDropdowns === 'function') {
          window.updateMobileMenuDropdowns(link);
        }
        return;
      }

      // If expanded and icon tapped, toggle (close) instead of navigating
      if (isIconClick) {
        e.preventDefault();
        if (typeof window.updateMobileMenuDropdowns === 'function') {
          window.updateMobileMenuDropdowns(link);
        }
        return;
      }

      // Else: expanded and label tapped -> allow navigation
    });
  });
})(window.jQuery || window.Zepto);
